//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import test1 from './test1'
	export default {
		components: {
			test1,

		},
		props:{
			shangbao:{
				type:Number,
				default:0
			},
			banjie:{
				type:Number,
				default:0
			},
			zong:{
				type:Number,
				default:0
			},
      qhslnum:{
        type:Number,
				default:0
      }
		},
		data() {
			return {
				dqshangbao:0,
				dqbanjie:'',
        dqzong:0,
        qhsl:0,
			};
		},
		created(){
		},
		watch:{
			qhslnum:{
				handler(val,old){
				 this.qhsl =val;
				},
				deep:true,
				immediate: true
			},
			shangbao:{
				handler(val,old){
				 this.dqshangbao =this.shangbao;
				},
				deep:true,
				immediate: true
			},
			zong:{
				handler(val,old){
				 this.dqzong =val;
				},
				deep:true,
				immediate: true
			},
			banjie:{
				handler(val,old){
				 this.dqbanjie=this.banjie;
				},
				deep:true,
				immediate: true

			}
		},
		mounted(){
		},
		destroyed(){
		},
		methods:{
		}
	}



// WEBPACK FOOTER //
// ./src/components/dangqian.vue